import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '../../../theme/scalingTokens';

export const useFeaturePillStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalXS,
    ...shorthands.padding('0.125rem', '0.5rem'),
    ...shorthands.borderRadius('0.75rem'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2,
    fontSize: fontScale.caption,
    fontWeight: '500',
    whiteSpace: 'nowrap',
    lineHeight: '1.33em',
    [mq.mobile]: {
      ...shorthands.padding('0.125rem', '0.375rem'),
    },
  },
  /**
   * Figma-aligned feature chip: white surface with neutral border and tighter
   * type. Opt-in.
   */
  figmaRoot: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderColor(tokens.colorNeutralStroke1),
    color: tokens.colorNeutralForeground1,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: fontScale.body,
  },
});
